import type { FreelancerDiplomasYearSelectionPageLocales } from '../types';

const freelancerDiplomasYearSelectionPageLocales: FreelancerDiplomasYearSelectionPageLocales =
  {
    foreignDiploma: 'Foreign diploma',
    helperMessage: 'Select the situation that applies to you.',
    nlDiplomaAfter2007: 'Dutch diploma after 2007',
    nlDiplomaFor2008: 'Dutch diploma befor 2008',
    title: 'Select diplomas year',
  };

export default freelancerDiplomasYearSelectionPageLocales;
